import styled from "styled-components";

export const Link = styled.span`
	text-decoration: underline;
	cursor: pointer;
	color: ${({ theme }) => theme.pantone2727C};
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;

export const AreaBackOrderBadge = styled.div`
	margin-top: 0.25rem;
`;

export const PartCellContent = styled.div`
	width: 100%;
	min-width: 0;

	.text-with-icon {
		display: inline-flex;
		width: 100%;
		max-width: 100%;
		min-width: 0;
	}

	.text-with-icon .text {
		display: block;
		min-width: 0;
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.supplierInventoryPartName .partName .text-content {
		display: block;
		min-width: 0;
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;
